import { IRecords } from '@/models/IRecord';
import { Chip } from '@destination/components';
import ModelAttributeCard from '../../details/ModelAttributeCard';
import { IOperation } from '@/models/IFunctionality';
import { slugify } from '@/utils/text-utils';
import RightArrow from '@icons/arrowRightIcon.svg?react';
import FunctionalityOperationDetail from './FunctionalityOperationDetail';

export interface IFunctionalityOperationsList {
  operations: IOperation[];
  records: IRecords;
  'data-testid'?: string;
}

export default function FunctionalityOperationsList({
  operations,
  records,
  'data-testid': dataTestId
}: IFunctionalityOperationsList) {
  if (!operations) return null;

  const titleComponent = (operation: IOperation) => (
    <div className="flex items-center w-full justify-between">
      <div className="tw-text-base w-1/4">{operation.name}</div>
      <div className="flex items-center w-3/4">
        {operation.input ? (
          <Chip label={operation.input.$ref} />
        ) : (
          <Chip label={'None'} />
        )}
        <RightArrow className="mx-3" />
        {operation.output ? (
          <Chip label={operation.output.$ref} />
        ) : (
          <Chip label={'None'} />
        )}
      </div>
    </div>
  );

  return (
    <div data-testid={dataTestId}>
      {operations.map(operation => {
        return (
          <ModelAttributeCard
            variant="LIGHT"
            key={slugify(operation.name)}
            title={titleComponent(operation)}
          >
            <div className="p-3 bg-slate-50">
              <FunctionalityOperationDetail
                operation={operation}
                records={records}
              />
            </div>
          </ModelAttributeCard>
        );
      })}
    </div>
  );
}
